import { render, staticRenderFns } from "./myClubBenefits.vue?vue&type=template&id=f5e74c1c&scoped=true"
import script from "./myClubBenefits.vue?vue&type=script&lang=js"
export * from "./myClubBenefits.vue?vue&type=script&lang=js"
import style0 from "./myClubBenefits.vue?vue&type=style&index=0&id=f5e74c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e74c1c",
  null
  
)

export default component.exports